// File: src/utils/constants.js

export const SECTOR_MAPPINGS = {
  'S&P500': 'SPY',
  'Basic Materials': 'XLB',
  'Communication Services': 'XLC',
  'Energy': 'XLE',
  'Financial Services': 'XLF',
  'Industrials': 'XLI',
  'Technology': 'XLK',
  'Consumer Defensive': 'XLP',
  'Real Estate': 'XLRE',
  'Utilities': 'XLU',
  'Healthcare': 'XLV',
  'Consumer Cyclical': 'XLY'
};

export const SECTOR_LIST = Object.keys(SECTOR_MAPPINGS);

export const TIME_PERIODS = ['1D', '1W', '1M', '3M', '6M', 'Inauguration'];

export const INAUGURATION_DATE = '2025-01-20';

export const POTUS_TABS = [
  { id: 'schedule', label: 'Presidential Schedule' },
  { id: 'orders', label: 'Executive Orders' },
  { id: 'posts', label: 'Truth Social Posts' }
];

export const formatDate = (dateString) => {
  if (!dateString) return '';
  
  return new Date(dateString).toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric', 
    month: 'long',
    day: 'numeric'
  });
};

export const formatTime = (timeString) => {
  if (!timeString) return '';
  
  try {
    return new Date(`2000-01-01 ${timeString}`).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  } catch (error) {
    return timeString;
  }
};

export const truncateText = (text, maxLength = 300) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const parsePostDate = (dateString) => {
  try {
    const parsed = new Date(dateString);
    if (isNaN(parsed.getTime())) {
      return new Date();
    }
    return parsed;
  } catch (error) {
    return new Date();
  }
};